import React from 'react'
import CanvasLogo from '../../../assets/icons/canvas-logo.svg'
import SuspensionModal from './SuspensionModal'
import { LevelTrackerSection, RequirementsSection } from './ProgressTrackerContent'
import { useMembershipJourneyContext } from './MembershipJourneyContext'
import {
  Container,
  SuspendedContentWrapper,
  DisabledOverlay,
  Header,
  TitleSection,
  Title,
  AssociateHeader,
  Divider,
  ProgramInfoItem,
  ProgramInfoLabel,
  ProgramInfoLink,
  PortalButton,
  PortalButtonText
} from './Styles/ProgressTracker.styles'

const SuspendedProgressTracker = ({
  levels,
  enrollmentDate,
  currentLevel,
  levelCompletionDate,
  patRequirementWithWarning,
  additionalRequirements,
  activeLevel,
  shouldShowPATWarning,
  shouldShowLevelCompleteBanner,
  shouldShowAdditionalRequirements,
  onLevelClick
}) => {
  const { careerPath } = useMembershipJourneyContext()
  
  return (
    <Container>
      <Header>
        <TitleSection>
          <Title>My Path to Membership</Title>
          {careerPath && (
            <ProgramInfoLink href="https://www.pga.org/membership/associate-program/path-to-membership-articles/career-paths/" target="_blank" rel="noopener noreferrer">
              {careerPath} ›
            </ProgramInfoLink>
          )}
        </TitleSection>
        {!!enrollmentDate && (
          <AssociateHeader>
            <ProgramInfoItem>
              <ProgramInfoLabel>Associate Program</ProgramInfoLabel>
              <ProgramInfoLink href="https://www.pga.org/membership/associate-program/" target="_blank" rel="noopener noreferrer">Details ›</ProgramInfoLink>
            </ProgramInfoItem>
            <Divider />
            <ProgramInfoItem>
              <ProgramInfoLabel>Enrolled: {enrollmentDate}</ProgramInfoLabel>
              <ProgramInfoLink href="https://www.pga.org/membership/Former-Associate/pga-associate-acceptable-progress-tracking" target="_blank" rel="noopener noreferrer">Guidelines ›</ProgramInfoLink>
            </ProgramInfoItem>
          </AssociateHeader>
        )}
      </Header>

      <SuspendedContentWrapper>
        <DisabledOverlay>
          <LevelTrackerSection 
            levels={levels}
            isSuspended
          />
        </DisabledOverlay>

        <DisabledOverlay>
          <RequirementsSection
            shouldShowLevelCompleteBanner={shouldShowLevelCompleteBanner}
            currentLevel={currentLevel}
            levelCompletionDate={levelCompletionDate}
            patRequirementWithWarning={patRequirementWithWarning}
            additionalRequirements={additionalRequirements}
            activeLevel={activeLevel}
            shouldShowPATWarning={shouldShowPATWarning}
            shouldShowAdditionalRequirements={shouldShowAdditionalRequirements}
            onLevelClick={onLevelClick}
          />
        </DisabledOverlay>

        <SuspensionModal />
      </SuspendedContentWrapper>

      <PortalButton>
        <img src={CanvasLogo} alt="Canvas Logo" />
        <PortalButtonText>Education Portal</PortalButtonText>
      </PortalButton>
    </Container>
  )
}

export default SuspendedProgressTracker

